import { render, staticRenderFns } from "./EralpButton.vue?vue&type=template&id=2bdb084b&"
import script from "./EralpButton.vue?vue&type=script&lang=js&"
export * from "./EralpButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports